export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/apps/pinterest.33e8cb8.svg";